import { V2Question } from "../helper";
import { CellValue, GridAnswers } from "./types";

interface BulkRow {
  givenToUserId: string;
  answers: Array<{ questionId: string; answer: CellValue }>;
}

const isEmpty = (value: CellValue): boolean => value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0);

// Required-field check for submitted rows (blank learners skipped); returns offending "{learnerId}:{questionId}" keys.
export const findMissingRequiredCells = (questions: V2Question[], answers: GridAnswers): string[] => {
  const required = questions.filter(question => question.isRequired);
  if (!required.length) return [];
  const missing: string[] = [];
  Object.keys(answers).forEach(learnerId => {
    const cell = answers[learnerId] || {};
    const hasAnyAnswer = Object.values(cell).some(value => !isEmpty(value));
    if (!hasAnyAnswer) return;
    required.forEach(question => {
      if (isEmpty(cell[question.id])) missing.push(`${learnerId}:${question.id}`);
    });
  });
  return missing;
};

// Grid state → bulk payload rows: one per learner with only answered questions; empty rows dropped.
export const buildBulkResponses = (questions: V2Question[], answers: GridAnswers): BulkRow[] => {
  const questionIds = questions.map(question => question.id);
  return Object.keys(answers)
    .map(learnerId => {
      const cell = answers[learnerId] || {};
      const rowAnswers = questionIds.filter(questionId => !isEmpty(cell[questionId])).map(questionId => ({ questionId, answer: cell[questionId] }));
      return { givenToUserId: learnerId, answers: rowAnswers };
    })
    .filter(row => row.answers.length > 0);
};
